// https://css-loaders.com/shapes/ #32

import { css, keyframes, styled } from 'styled-components';

const resize = (size: number) => keyframes`
  0%,
  100% {
    width: ${size * 0.275}rem;
    height: ${size * 0.275}rem;
  }
  35%,
  65% {
    width: ${size * 0.425}rem;
    height: ${size * 0.425}rem;
  }
`;

const reposition = keyframes`
  0%,
  40% {
    background-position:
      0 0,
      0 50%,
      0 100%,
      50% 100%,
      100% 100%,
      100% 50%,
      100% 0,
      50% 0,
      50% 50%;
  }
  60%,
  100% {
    background-position:
      0 50%,
      0 100%,
      50% 100%,
      100% 100%,
      100% 50%,
      100% 0,
      50% 0,
      0 0,
      50% 50%;
  }
`;

const Loader = styled('div').withConfig({
  shouldForwardProp: (prop) => !['size', 'color'].includes(prop),
})<{ size?: number; color?: string }>`
  transform: scaleX(-1);

  ${({ size = 40, color = '#fff' }) => css`
    --c: no-repeat linear-gradient(${color} 0 0);
    background: var(--c), var(--c), var(--c), var(--c), var(--c), var(--c),
      var(--c), var(--c), var(--c);
    width: ${size}rem;
    height: ${size}rem;
    background-size: ${size * 0.0875}rem ${size * 0.0875}rem;
    animation: ${resize(size)} 1.5s infinite, ${reposition} 1.5s infinite;
  `}
`;

export default Loader;
